<template>
  <EStickyFooterLayout>
    <template #header>
      <EMainHeader
        personal-counter-increment
        data-test-id="layout-header"
        :search-hidden-inputs="searchHiddenInputs"
      >
        <template #navigation>
          <ENavigation :shopping-link="hasShoppingLink" data-test-id="layout-navigation" />
        </template>
        <template v-if="filtersShown" #filters>
          <EFilters :filters="filters" />
        </template>
      </EMainHeader>
    </template>
    <template #content>
      <Nuxt data-test-id="layout-content" />
    </template>
    <template #footer>
      <EMainFooter data-test-id="layout-footer" />
    </template>
  </EStickyFooterLayout>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import EStickyFooterLayout from '~~/common/vue/components/layouts/sticky-footer';
import EMainHeader from '~~/common/vue/components/main-header';
import EMainFooter from '~~/common/vue/components/main-footer';
import ENavigation from '~~/search/common/vue/components/navigation';
import EFilters from '~~/search/common/vue/components/filters';
import filters from '~/filters';

export default {
  head() {
    return {
      htmlAttrs: { lang: this.$store.state.global.locale },
      title: `${this.$route.query.q?.toString() || ''} - Ecosia`,
      meta: [
        { hid: 'description', name: 'description', content: this.$t('common.header.share.subheader') },
        { property: 'og:title', name: 'og:title', content: this.$t('common.header.share') },
        { property: 'og:description', name: 'og:description', content: this.$t('common.header.share.subheader') },
      ],
    };
  },
  components: {
    EStickyFooterLayout,
    EFilters,
    ENavigation,
    EMainHeader,
    EMainFooter,
  },
  computed: {
    ...mapState('global', ['locale']),
    ...mapState('search', ['filtersShown']),
    ...mapState('user', ['appUserSnowplowId', 'isEcosiaApp']),
    ...mapGetters(['hasShoppingLink']),
    searchHiddenInputs() {
      // The reason this is an unfriendly '_sp' is because this is a
      // built in feature of snowplow that we are using. So it has to be.
      // https://snowplowanalytics.com/blog/2015/03/15/snowplow-javascript-tracker-2.4.0-released/#cross-domain
      // eslint-disable-next-line no-underscore-dangle
      return (this.isEcosiaApp) ? { _sp: this.appUserSnowplowId } : {};
    },
    filters() {
      // enrich the static filter config with translated strings
      return filters.map((config) => {
        config.hint = this.$t(`web.filters.${config.id}.hint`);
        config.placeholder = this.$t(`web.filters.${config.id}.placeholder`);
        config.options = config.options.map((option) => {
          option.label = this.$t(`web.filters.${config.id}.options.${option.value}`);
          return option;
        });
        return config;
      });
    },
  },
};
</script>
